<template>
<div>
    <router-view v-slot="{ Component }">
      <keep-alive :include="cachedViews">
        <component :is="Component" />
      </keep-alive>
    </router-view>
</div>
</template>
<script>
import { ref } from 'vue'
export default {
  setup () {
    const cachedViews = ref(['Restaurant'])
    return { cachedViews }
  }
}
</script>
